import { on } from '../core/bus.js';

const SELECTOR = '[name="product-quantity-spin"]';

const BUTTON_CONFIG = {
  verticalupclass: 'material-icons touchspin-up',
  verticaldownclass: 'material-icons touchspin-down',
  buttondown_class: 'btn btn-touchspin js-touchspin js-increase-product-quantity',
  buttonup_class: 'btn btn-touchspin js-touchspin js-decrease-product-quantity',
};

function jquery() {
  return window.jQuery || window.$;
}

function isEnhanced(input) {
  return input.closest('.bootstrap-touchspin') !== null;
}

function initOne(input) {
  if (isEnhanced(input)) {
    return;
  }

  jquery()(input).TouchSpin({
    ...BUTTON_CONFIG,
    min: parseInt(input.getAttribute('min'), 10),
    max: 1000000,
  });
}

export function initSpinners() {
  document.querySelectorAll(SELECTOR).forEach(initOne);
}

export function destroySpinners() {
  const $ = jquery();

  document.querySelectorAll(SELECTOR).forEach((input) => {
    if (isEnhanced(input)) {
      $(input).trigger('touchspin.destroy');
    }
  });
}

export function registerQuantitySpin() {
  initSpinners();
  on('fragment:applied', initSpinners);
}
